/* eslint-disable quotes */
export const frTranslations = {};
